
/* injects from baggage-loader */

'use strict';

const profileImage = require('_images/page-six/profile-maria.png');
const readMoreImage = require('_images/page-six/read-more.png');

export default class PageSixController {
    constructor($state, $timeout, Dialog) {
        'ngInject'; 
        this.$state = $state;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$state = $state;
        this.profileImage = profileImage;        

        this.state = {
            step: 1
        }
    }

    $onInit(){ 
        this.embedded = require('_images/page-six/feedback.png');
    }

    $onDestroy(){
        this.resetStage();
    }

    resetStage() {        
        return false;
    }

    readMore(){
        this.Dialog.showEmbedded(readMoreImage);
    }

    redirectToStages(){
        this.$state.go("page-seven");
    }
    toInterview(){
        this.Dialog.showInterview(this.onFinishInterview.bind(this))
    }
    onFinishInterview(){
        this.Dialog.showEmbedded(this.embedded, 0, this.redirectToStages.bind(this));
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/page-six/page-six.controller.js